import { render, staticRenderFns } from "./mj.vue?vue&type=template&id=8f2df4b4&scoped=true"
import script from "./mj.vue?vue&type=script&lang=js"
export * from "./mj.vue?vue&type=script&lang=js"
import style0 from "./mj.vue?vue&type=style&index=0&id=8f2df4b4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2df4b4",
  null
  
)

export default component.exports